<template>
  <div>

    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="1200">
      <material-card :title="$t(formTitle)" :icon="formIcon" :color="formColor">
        <v-card-text v-if="item">
          <v-form ref="form" v-model="valid">
            <v-container fluid fill-height>
              <v-row wrap>
                <v-col cols="12" md="4" lg="3">
                  <trans-select2
                    v-model="item"
                    propertyName="Employer"
                    :items="employers"
                    :label="$t('headers.members_management.Employer')"
                    field="Name"
                    itemValue="Identifier"
                    class="required"
                    :rules="[$rules.required]"
                  ></trans-select2>
                </v-col>
              </v-row>
              <v-card-text>
                {{ $t("headers.plancoveragecommencement.conditions") }}
              </v-card-text>
              <v-card-actions>
                <v-btn dark color="success" @click="addConditionElement">
                  <v-icon>add</v-icon>
                  {{ $t("globals.add") }}
                </v-btn>
              </v-card-actions>
              {{ item.ConditionElementss }}
              <v-expansion-panels accordion multiple>
                <v-expansion-panel
                  v-for="(conditionElement, index) in item.Conditions"
                  :key="index"
                >
                  <v-expansion-panel-header>
                    {{
                      $t("headers.plancoveragecommencement.rule_{0}", [
                        index + 1,
                      ])
                    }}
                    <v-spacer />
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card-actions>
                      <v-btn
                        dark
                        color="error"
                        small
                        @click="removeConditionElement(index)"
                      >
                        <v-icon>delete</v-icon>
                        {{ $t("globals.remove") }}
                      </v-btn>
                    </v-card-actions>
                    <v-row wrap>
                      <v-col cols="12" md="12">
                        <logical-expressions
                          :headers="logicalExpressionsHeaders"
                          @apply="saveLogicalExpressions($event, index)"
                          @valid="expressionsValid = $event"
                          :externalFilters="conditionElement.Expressions"
                          :dropdownItems="dropdownItems"
                          languageCode="fr"
                        />
                      </v-col>
                    </v-row>
                    <v-row wrap>
                      <v-col cols="12" md="4" lg="3">
                        <v-checkbox
                          :label="
                            $t(
                              'headers.plancoveragecommencement.choose_check_period'
                            )
                          "
                          v-model="conditionElement.chooseCheckPeriod"
                          @change="choseCheckPeriodChecked($event, index)"
                        />
                      </v-col>
                      <template v-if="conditionElement.chooseCheckPeriod">
                        <v-col cols="12" md="4" lg="3">
                          <!-- <auto-select
                            :value.sync="conditionElement.PeriodType"
                            :items="options.Enums.PeriodType"
                            :label="
                              $t('headers.plancoveragecommencement.period_type')
                            "
                            :rules="[$rules.required]"
                            :slots="true"
                            :filter="filterFunc"
                            class="required"
                          >
                            <template v-slot:selection="data">
                              {{ $t("enums." + data.item) }}
                            </template>
                            <template v-slot:item="data">
                              <v-list-item-content
                                v-text="$t('enums.' + data.item)"
                              ></v-list-item-content>
                            </template>
                          </auto-select> -->
                          <trans-enum
                            :value.sync="conditionElement.PeriodType"
                            :items="options.Enums.PeriodType"
                            :label="
                              $t('headers.plancoveragecommencement.period_type')
                            "
                            :rules="[$rules.required]"
                            class="required"
                          ></trans-enum>
                        </v-col>
                        <v-col cols="12" md="4" lg="3">
                          <no-autocomplete-textfield
                            :value="conditionElement.PeriodUnit"
                            @change="conditionElement.PeriodUnit = $event"
                            :label="
                              $t('headers.plancoveragecommencement.period_unit')
                            "
                            :rules="[$rules.requiredNum, $rules.integer]"
                            type="number"
                            class="required"
                          ></no-autocomplete-textfield>
                        </v-col>
                        <v-col cols="12" md="4" lg="3">
                          <!-- <auto-select
                            :value.sync="conditionElement.CheckCondition"
                            :items="options.Enums.CheckCondition"
                            :label="
                              $t(
                                'headers.plancoveragecommencement.check_condition'
                              )
                            "
                            :rules="[$rules.required]"
                            :slots="true"
                            :filter="filterFunc"
                            class="required"
                          >
                            <template v-slot:selection="data">
                              {{ $t("enums." + data.item) }}
                            </template>
                            <template v-slot:item="data">
                              <v-list-item-content
                                v-text="$t('enums.' + data.item)"
                              ></v-list-item-content>
                            </template>
                          </auto-select> -->
                          <trans-enum
                            :value.sync="conditionElement.CheckCondition"
                            :items="options.Enums.CheckCondition"
                            :label="
                              $t(
                                'headers.plancoveragecommencement.check_condition'
                              )
                            "
                            :rules="[$rules.required]"
                            class="required"
                          ></trans-enum>
                        </v-col>
                      </template>
                      <v-col cols="12" md="4" lg="3">
                        <v-checkbox
                          :label="
                            $t(
                              'headers.plancoveragecommencement.skip_current_month_on_check'
                            )
                          "
                          v-model="conditionElement.SkipCurrent"
                        />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-row wrap>
                <v-col cols="12" md="4" lg="3">
                  <!-- <auto-select
                    :value.sync="item.Eligible"
                    :items="options.Enums.Eligible"
                    :label="$t('components.memberview.eligible')"
                    :rules="[$rules.required]"
                    :slots="true"
                    :filter="filterFunc"
                    class="required"
                  >
                    <template v-slot:selection="data">
                      {{ $t("enums." + data.item) }}
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content
                        v-text="$t('enums.' + data.item)"
                      ></v-list-item-content>
                    </template>
                  </auto-select> -->
                  <trans-enum
                    :value.sync="item.ChangeDate"
                    :items="options.Enums.ChangeDate"
                    :label="$t('components.memberview.eligible')"
                    :rules="[$rules.required]"
                    class="required"
                  ></trans-enum>
                </v-col>
              </v-row>
              <v-row wrap>
                <v-card-text>
                  {{ $t("components.plancreationwizard.assign_to") }}
                </v-card-text>
                <v-col cols="12" md="4" lg="3">
                  <trans-select2
                    v-model="item"
                    propertyName="MemberGroupIdentity"
                    :items="memberGroups"
                    :label="$t('headers.members_management.Member Group')"
                    field="Name"
                    itemValue="Identifier"
                    class="required"
                    :rules="[$rules.required]"
                  ></trans-select2>
                </v-col>
                <v-col cols="12" md="4" lg="3" v-if="hasClasses">
                  <v-autocomplete
                    v-model="item.Class"
                    :items="classesArray"
                    :label="$t('headers.members_management.Class')"
                    :rules="[$rules.required]"
                    class="required"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="4" lg="3" v-if="hasDefaultCoverage">
                  <trans-select
                    :item="item"
                    propertyName="DefaultCoverageStatus"
                    :items="options.Models.FamilyStatus"
                    :label="
                      $t('headers.members_management.Default Coverage Status')
                    "
                    class="required"
                    :rules="[$rules.required]"
                  ></trans-select>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid || !expressionsValid"
            color="primary"
            @click="saveItem"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="dialogs.delete" scrollable persistent max-width="400">
      <material-card
        :title="
          $t(
            'components.plancreationwizard.remove_plan_coverage_commencement_rules'
          )
        "
        :color="$vuetify.theme.themes.light.error"
        icon="remove"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="removeItem">
            {{ $t("globals.remove") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-col cols="12">
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="planCoverageCommencementRules"
        identifier="planCoverageCommencementTable"
        @error="error = $event"
      ></pbas-data-table>
    </v-col>
    <error-handler :error="error"></error-handler>
    <!-- </material-card> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { InMemoryProvider } from "pbas-vue-components";
import getPlanCoverageCommencementHeaders from "@/headers/PlanCoverageCommencement";
import ErrorHandler from "@/components/ErrorHandler";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import TransSelect from "@/components/TransSelect";
import AutoSelect from "@/components/AutoSelect";
import TransSelect2 from "@/components/TransSelect2";
import { translate2 } from "@/trans2";
import TransEnum from "@/components/TransEnum.vue";

export default {
  components: {
    ErrorHandler,
    TransSelect2,
    NoAutocompleteTextfield,
    AutoSelect,
    TransSelect,
    TransEnum,
  },
  props: [
    "planCoverageCommencementRules",
    "hasClasses",
    "hasDefaultCoverage",
    "employers",
    "classesArray",
    "memberGroups",
    "planIdentityId",
    "logicalExpressionsHeaders",
    "logicalExpressionsFields",
  ],
  data() {
    return {
      error: null,
      valid: false,
      dialogs: {
        edit: false,
        delete: false,
      },
      item: null,
      isNew: false,
      floatActions: [
        {
          name: "addPlanCoverageCommencementRule",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.item = {
              Identifier: Math.random().toString(),
              PlanIdentityId: this.planIdentityId,
              Conditions: [
                {
                  Identifier: Math.random().toString(),
                },
              ],
            };
            this.isNew = true;
            this.dialogs.edit = true;
          },
        },
      ],
      rowActions: [
        {
          name: "editPlanCoverageCommencementRule",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.item = JSON.parse(JSON.stringify(item));
            if (
              this.item.Conditions === null ||
              this.item.Conditions === undefined
            ) {
              this.item.Conditions = [
                {
                  Identifier: Math.random().toString(),
                },
              ];
            }
            for (const el of this.item.Conditions) {
              if (el.PeriodType || el.PeriodUnit || el.CheckCondition) {
                el.chooseCheckPeriod = true;
              }
            }
            this.isNew = false;
            this.dialogs.edit = true;
          },
        },
        {
          name: "removePlanCoverageCommencementRule",
          icon: "delete",
          title: "globals.remove",
          handler: (item) => {
            this.item = JSON.parse(JSON.stringify(item));
            this.dialogs.delete = true;
          },
        },
      ],
      provider: undefined,
      headers: [],
      expressionsValid: false,
      dropdownItems: {},
    };
  },
  computed: {
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", ["language"]),
    formTitle() {
      return this.isNew
        ? "components.plancreationwizard.create_new_plan_coverage_commencement_rule"
        : "components.plancreationwizard.edit_plan_coverage_commencement_rule";
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    planCoverageCommencementRules: {
      handler(v) {
        if (this.provider !== null && this.provider !== undefined) {
          this.provider.items = v;
          this.$refs.table.getDataAsync();
          console.log("------------------------------------------------------------", v);
        } else {
          this.provider = new InMemoryProvider(v, this.headers);
        }
      },
    },
    logicalExpressionsFields: {
      handler(v) {
        if (v !== null && v !== undefined) {
          console.log(this.provider.items, v);
          this.dropdownItems = {};
          for (let field of v) {
            if (field.Type === "Enum") {
              let parts = field.EnumName.split(".");
              this.dropdownItems[field.Name] = this.options[parts[0]][parts[1]];
            }
          }
          // if (v.filter(o=>o.Name==="DefaultCoverageStatus")) {

          // }
          for (let item of this.provider.items) {
            console.log(item);
            for (let condition of item.Conditions) {
              console.log(condition);
              let expressions = [];
              let translatedExpressions = [];
              let parameters = [];
              let pDictionary = {};
              for (let parameter of condition.UsedParameters) {
                console.log(
                  parameter,
                  condition.Expressions,
                  condition.TranslatedExpressions,
                  condition.UsedParameters
                );
                if (Object.keys(pDictionary).indexOf(parameter) === -1) {
                  pDictionary[parameter] = 0;
                } else {
                  pDictionary[parameter]++;
                }
                
                if (v.filter((o) => o.Name === parameter).length > 0) {
                  let expression = condition.Expressions.filter(
                    (o) => o.indexOf(parameter) > -1
                  );
                  if (expression.length > 0) {
                    expressions.push(expression[pDictionary[parameter]]);
                    parameters.push(parameter);
                  }
                  expression = condition.TranslatedExpressions.filter(
                    (o) => o.indexOf(parameter) > -1
                  );
                  if (expression.length > 0) {
                    translatedExpressions.push(expression[pDictionary[parameter]]);
                  }
                }
              }
              condition.Expressions = expressions;
              condition.TranslatedExpressions = translatedExpressions;
              condition.UsedParameters = parameters;
            }
          }

          this.$emit(
            "update-plan-coverage-commencement-rules",
            this.provider.items
          );
        }
      },
    },
    hasClasses: {
      handler(v) {
        console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%")
        if (this.item !== null && this.item !== undefined && !v) {
          delete this.item.Class;
        }
        this.loadData();
      },
    },
    hasDefaultCoverage: {
      handler(v) {
        console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$", v);
        if (this.item !== null && this.item !== undefined && !v) {
          delete this.item.DefaultCoverageStatus;
        }
        if (!v) {
          for (let item of this.provider.items) {
            delete item.DefaultCoverageStatus;
          }
        }

        this.loadData();
      },
    },
    classesArray: {
      handler(v) {
        if (v === null || v === undefined) {
          if (this.provider !== null && this.provider !== undefined) {
            for (let rule of this.provider.items) {
              delete rule.Class;
            }
          }
          this.$refs.table.getDataAsync();
          this.$emit(
            "update-plan-coverage-commencement-rules",
            this.provider.items
          );
        } else {
          if (this.provider !== null && this.provider !== undefined) {
            for (let rule of this.provider.items) {
              if (v.indexOf(rule.Class) === -1) {
                delete rule.Class;
              }
            }
            this.$refs.table.getDataAsync();
            this.$emit(
              "update-plan-coverage-commencement-rules",
              this.provider.items
            );
            console.log("#################################################", v)
          }
        }
      },
    },
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    choseCheckPeriodChecked(value, index) {
      console.log(value, index);
      this.item.Conditions[index].chooseCheckPeriod = value;
      if (!value) {
        delete this.item.Conditions[index].PeriodType;
        delete this.item.Conditions[index].PeriodUnit;
        delete this.item.Conditions[index].CheckCondition;
      }
      this.$forceUpdate();
    },
    addConditionElement() {
      this.item.Conditions.push({
        Identifier: Math.random().toString(),
      });
    },
    removeConditionElement(index) {
      console.log("remove: ", index, JSON.stringify(this.item.Conditions));
      this.item.Conditions.splice(index, 1);
      if (this.item.Conditions.length === 0) {
        this.addConditionElement();
      }
      console.log("remove: after: ", JSON.stringify(this.item.Conditions));
    },
    loadData() {
      this.headers = getPlanCoverageCommencementHeaders(
        this.hasClasses,
        this.hasDefaultCoverage
      );
      if (
        this.planCoverageCommencementRules !== null &&
        this.planCoverageCommencementRules !== undefined
      ) {
        this.provider = new InMemoryProvider(
          this.planCoverageCommencementRules,
          this.headers
        );
      }
    },
    saveLogicalExpressions(items, index) {
      console.log("save logical expressions: ", items);
      this.item.Conditions[index].Expressions = items.expressions;
      this.item.Conditions[index].TranslatedExpressions =
        items.translatedExpressions;
      this.item.Conditions[index].UsedParameters = items.usedParameters;
    },
    translate2(item, field) {
      return translate2(item, field);
    },

    saveItem() {
      let item = JSON.parse(JSON.stringify(this.item));

      if (this.isNew) {
        this.addItem(item);
      } else {
        this.updateItem(item);
      }
    },

    updateItem(item) {
      let memberEligibility;
      memberEligibility = this.provider.items.filter(
        (o) => o.Identifier === item.Identifier
      )[0];
      this.provider.items[this.provider.items.indexOf(memberEligibility)] =
        item;
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit(
        "update-plan-coverage-commencement-rules",
        this.provider.items
      );
    },

    addItem(item) {
      this.provider.items.push(item);
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit(
        "update-plan-coverage-commencement-rules",
        this.provider.items
      );
    },

    removeItem() {
      let item;
      item = this.provider.items.filter(
        (o) => o.Identifier === this.item.Identifier
      )[0];

      this.provider.items.splice(this.provider.items.indexOf(item), 1);
      this.close();
      this.$refs.table.getDataAsync();
      this.$emit(
        "update-plan-coverage-commencement-rules",
        this.provider.items
      );
    },
    close() {
      this.dialogs.edit = false;
      this.dialogs.delete = false;
      this.item = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
  },
};
</script>

<style></style>
